import Ui from '../../../client/ui'

export default class
{
	static try(user:string, password:string):void
	{
		Ui.post('/login', {
			user    : user,
			password: password,
		}, (success:boolean) => {
			if(success) location.reload()
		})
	}
}
